import { render, staticRenderFns } from "./I20UploadFile.vue?vue&type=template&id=7f0dbf38&scoped=true&"
import script from "./I20UploadFile.vue?vue&type=script&lang=js&"
export * from "./I20UploadFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0dbf38",
  null
  
)

export default component.exports